var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.999,
    cy: 11.983,
    r: 8.8,
    fill: "#1D9BF0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#twitter_svg__clip0_6286_64100)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.299 15.65a6.063 6.063 0 0 1-2.881-.732c.13.029.295.029.458.029.884 0 1.703-.254 2.325-.704-.819 0-1.506-.479-1.768-1.126.098.028.229.028.36.028.164 0 .327-.028.491-.056-.851-.14-1.506-.788-1.506-1.576v-.028c.262.112.557.197.851.197-.49-.282-.85-.788-.85-1.351 0-.31.097-.563.261-.816.917.985 2.324 1.632 3.863 1.688-.033-.112-.033-.253-.033-.365 0-.901.852-1.605 1.866-1.605.557 0 1.015.197 1.375.507.426-.084.819-.197 1.179-.394a1.662 1.662 0 0 1-.818.9 3.32 3.32 0 0 0 1.113-.253c-.262.338-.557.62-.95.845v.197c.033 2.139-1.866 4.615-5.336 4.615"
  }))));
};
export default SvgTwitter;